export default function getNowMonth(){
    let syear=new Date().getFullYear();
    let smonth=new Date().getMonth()+1
    console.log(smonth)
    let start=syear+"-"+getstr(smonth)+"-"+"01"
    let endtime= new Date(syear, smonth, 0)
    let sday=endtime.getDate()
    let end=syear+"-"+getstr(smonth)+"-"+sday
    console.log([start,end])
    return [start,end]
}
function getstr(s){
    if(s<10){
        s="0"+s.toString()
    }else{
        s=s
    }
    return s
}


// WEBPACK FOOTER //
// ./src/utils/getNowMonth.js